export const COOKIE_TYPE = {
  ESSENTIAL: 'Essential_cookies',
  PERFORMANCE: 'Performance_cookies',
  MARKETING: 'Marketing_cookies',
};
